// Adapta o vue-select sem alterar seus modelos, filtros, slots ou valores.
export function createSearchSelect(Base) {
  return {
    extends: Base,
    name: 'GlobalSearchSelect',
    data: () => ({ previewSelectedText: false }),
    computed: {
      filteredOptions() {
        if (this.mutableLoading) return []
        if (this.$attrs['data-pesquisa-contexto'] && !this.search.trim()) return []
        return Base.computed.filteredOptions.call(this).filter(option => !option?.__appNativeHidden)
      }
    },
    watch: {
      disabled(value) { if (value) this.open = false },
      open(value) { if (!value) this.previewSelectedText = false }
    },
    beforeDestroy() { if (this._selectTextFrame != null) cancelAnimationFrame(this._selectTextFrame) },
    updated() { if (this.open && this.$refs.search?.matches(':disabled')) this.open = false },
    methods: {
      select(option) { if (!this.disabled && !this.$refs.search?.matches(':disabled')) Base.methods.select.call(this, option) },
      focus() { this.$refs.search?.focus() },
      selectFieldText() {
        if (this.multiple || this.noDrop) return
        this.$nextTick(() => {
          if (this._selectTextFrame != null) cancelAnimationFrame(this._selectTextFrame)
          this._selectTextFrame = requestAnimationFrame(() => { if (this.open && !this.disabled) this.$refs.search?.select() })
        })
      },
      prepareSelectedText() { this.previewSelectedText = !this.multiple && !this.search && !!this.selectedValue.length },
      onSearchFocus(event) {
        this.prepareSelectedText()
        Base.methods.onSearchFocus.call(this, event)
        this.selectFieldText()
      },
      toggleDropdown(event) {
        if (this.disabled || this.$refs.search?.matches(':disabled')) { event.preventDefault(); return }
        if (!this.open) this.prepareSelectedText()
        Base.methods.toggleDropdown.call(this, event)
        if (this.open) this.selectFieldText()
      },
      onSearchKeyDown(event) {
        if (event.isComposing || event.keyCode === 229) return
        if (this.previewSelectedText && !event.ctrlKey && !event.altKey && !event.metaKey && (event.key?.length === 1 || ['Backspace', 'Delete'].includes(event.key))) this.$refs.search?.select()
        if (event.key === 'Enter' && this.mutableLoading && !event.ctrlKey && !event.altKey && !event.metaKey) { event.preventDefault(); event.stopPropagation(); return }
        if (event.key === 'Enter' && (event.ctrlKey || event.altKey || event.metaKey || event.repeat || !this.dropdownOpen)) return
        const wasOpen = this.dropdownOpen
        if (!wasOpen && ['ArrowDown', 'ArrowUp'].includes(event.key)) this.prepareSelectedText()
        Base.methods.onSearchKeyDown.call(this, event)
        if (!wasOpen && this.dropdownOpen) this.selectFieldText()
        if (wasOpen && ['Escape', 'ArrowDown', 'ArrowUp'].includes(event.key)) { event.preventDefault(); event.stopPropagation() }
      },
      maybeAdjustScroll() {
        const list = this.$refs.dropdownMenu, option = list?.querySelectorAll('[role="option"]')[this.typeAheadPointer]
        if (!list || !option) return
        const bounds = list.getBoundingClientRect(), rect = option.getBoundingClientRect()
        if (rect.top < bounds.top) list.scrollTop -= bounds.top - rect.top
        else if (rect.bottom > bounds.bottom) list.scrollTop += rect.bottom - bounds.bottom
      }
    },
    render(h) {
      const root = Base.render.call(this)
      if (this.noDrop) return root
      root.data.class = [root.data.class, 'app-search-select']
      const visit = node => {
        if (!node) return node
        if (node.data?.ref === 'toggle') node.data.attrs['aria-label'] = this.$attrs['aria-label'] || this.placeholder || 'Selecionar opção'
        if (node.data?.ref === 'clearButton') { node.data.attrs.title = 'Limpar seleção'; node.data.attrs['aria-label'] = 'Limpar seleção' }
        if (node.tag === 'input' && node.data?.ref === 'search') {
          const input = node.data.on.input
          if (this.open && this.previewSelectedText && !this.multiple) node.data.domProps = { ...node.data.domProps, value: String(this.getOptionLabel(this.selectedValue[0]) ?? '') }
          node.data.on.input = event => { if (this._selectTextFrame != null) cancelAnimationFrame(this._selectTextFrame); this.previewSelectedText = false; if (Array.isArray(input)) input.forEach(fn => fn(event)); else input?.(event) }
          for (const name of ['beforeinput', 'paste', 'compositionstart']) {
            const handler = node.data.on[name]
            node.data.on[name] = event => { if (this.previewSelectedText && !this.multiple) this.$refs.search?.select(); if (Array.isArray(handler)) handler.forEach(fn => fn(event)); else handler?.(event) }
          }
          node.data.on.click = this.selectFieldText
          node.data.attrs.readonly = false
          node.data.attrs['aria-label'] = this.$attrs['aria-label'] || this.placeholder || 'Pesquisar e selecionar opção'
          for (const attr of ['aria-invalid', 'aria-describedby', 'aria-required', 'aria-errormessage']) if (this.$attrs[attr] != null) node.data.attrs[attr] = this.$attrs[attr]
        }
        if (node.tag === 'li' && node.data?.attrs?.role === 'option') {
          const index = Number(String(node.data.attrs.id).split('-').pop())
          const checked = this.isOptionSelected(this.filteredOptions[index])
          node.data.attrs['aria-selected'] = String(checked)
          node.children = [h('span', { class: 'app-select-option-label' }, node.children), ...(checked ? [h('span', { class: 'app-select-check', attrs: { 'aria-hidden': 'true' } }, '✓')] : [])]
        }
        if (node.children) node.children = node.children.map(visit)
        if (node.componentOptions?.children) node.componentOptions.children = node.componentOptions.children.map(visit)
        if (node.tag === 'ul' && node.data?.ref === 'dropdownMenu') {
          const directives = node.data.directives
          node.data.directives = []
          if (!this.filteredOptions.length) node.children = [h('li', { class: 'vs__no-options', attrs: { role: 'presentation' } }, this.mutableLoading ? 'Buscando…' : this.$attrs['data-pesquisa-contexto'] && !this.search.trim() ? 'Digite para pesquisar.' : this.$scopedSlots['no-options']?.(this.scope.listHeader) || 'Nenhum resultado encontrado.')]
          return h('div', { key: node.key + '-panel', class: 'app-select-panel', directives }, [node])
        }
        return node
      }
      return visit(root)
    }
  }
}
